import React, { useEffect, useRef, useState} from 'react'
import styles from './VacationPage.module.css'
import {
    Button, Dialog, DialogActions, DialogContent, DialogContentText,
} from '@material-ui/core'

import axios from "axios";
import LoadingBackdrop from "../../../components/common/LoadingBackdrop";
import Snackbar from "@mui/material/Snackbar";
import {getConfig} from "../../../AppConfig";
import {useForm} from "react-hook-form";
import {Alert, Container, FormControl, FormLabel, Grid, IconButton, Toolbar} from "@mui/material";
import {useParams} from "react-router";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";

const VacationPage = (params) => {
    const [snackbarOpen, setSnackbarOpen] = React.useState({ open: false, message: '' })
    const [dialogMsg, setDialogMsg] = React.useState( '');
    const [loadingBackdrop, setLoadingBackdrop] = React.useState(false)
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [comment, setComment] = useState("");
    const [errors, setErrors] = useState({
        startDate: "",
        endDate: "",
    });

    useEffect(() => {
        params.setTitle('Add Vacation')
    }, [])

    const closeDialog = () => {
        setDialogMsg("")
    }

    const onSubmit = async () => {
        if (validateDates()) {
            setLoadingBackdrop(true)
            const body = {
                startdate: startDate,
                enddate: endDate,
                comment: comment
            }

            axios.put(`fieldsystemvacation`, body).then((response) => {
                const parsedResponse = JSON.parse(response?.data.jsonString)
                setLoadingBackdrop(false)
                // setSnackbarOpen( { open: true, message: parsedResponse.message})
                setDialogMsg(parsedResponse.message)
            })
        }
    }

    const validateDates = () => {
        // const currentDate = new Date().toISOString().slice(0, 10);
        let isValid = true;
        let newErrors = {
            startDate: "",
            endDate: "",
        }

        const start = Date.parse(startDate);
        const end = Date.parse(endDate);
        if (!start) {
            newErrors.startDate = "Please select a start date.";
            isValid = false;
        }
        if (!end) {
            newErrors.endDate = "End date must be equal to or before the start date.";
            isValid = false;
        }
        if (end < start) {
            newErrors.endDate = "End date must be equal to or after the start date.";
            isValid = false;
        }

        setErrors(newErrors)
        return isValid
    }


    const handleSnackbarClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setSnackbarOpen({ open: false, message: ""  });
    }

    return (
        <div className={styles.root}>
            <LoadingBackdrop open={loadingBackdrop} />
            <>
                <Dialog
                    open={dialogMsg.length > 0}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {dialogMsg}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={closeDialog}>Ok</Button>
                    </DialogActions>
                </Dialog>
            </>
            <>
                <Snackbar
                    open={snackbarOpen.open}
                    autoHideDuration={4000}
                    onClose={handleSnackbarClose}
                    anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                >
                    <Alert severity="success">
                        {snackbarOpen.message}
                    </Alert>
                </Snackbar>
            </>
            <>
                <div style={{display: loadingBackdrop ? 'none' : 'inline-flex'}}>
                    <Container>
                        <Box>
                            <Grid
                                container
                                border={0}
                                direction="row"
                                alignItems="center"
                                justifyContent="center"
                                height={'100%'}
                                width={'100%'}
                            >
                                <>
                                    <Grid item border={0} marginRight={1} md={8} xs={8}>
                                        {/*<div style={{marginBottom: '50', justifyContent: 'center', alignItems: 'center', alignContent:'center'}} >Add vacation days.</div>*/}
                                        <TextField
                                            autoFocus
                                            margin="dense"
                                            id="startDate"
                                            label="Start Date"
                                            type="date"
                                            fullWidth
                                            value={startDate}
                                            onChange={(e) => (setStartDate(e.target.value))}
                                            error={!!errors.startDate}
                                            helperText={errors.startDate}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                        <TextField
                                            margin="dense"
                                            id="endDate"
                                            name="endDate"
                                            label="End Date"
                                            type="date"
                                            fullWidth
                                            value={endDate}
                                            onChange={(e) => setEndDate(e.target.value)}
                                            error={!!errors.endDate}
                                            helperText={errors.endDate}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                        <TextField
                                            margin="dense"
                                            id="comment"
                                            label="Comment"
                                            type="text"
                                            fullWidth
                                            defaultValue={comment}
                                            value={comment}
                                            onChange={(e) => setComment(e.target.value)}
                                        />
                                        <Button
                                            style={{marginTop: '20px', alignItems: 'center', width: '100%'}}
                                            variant="contained"
                                            className={styles.submitButton}
                                            type="submit"
                                            onClick={() => {onSubmit()}}
                                            form="items-form">
                                            Submit
                                        </Button>
                                    </Grid>
                                </>
                            </Grid>
                        </Box>
                    </Container>
                </div>

            </>
        </div>
    )
}

export default VacationPage